<template>
  <div :class="uppyClass"></div>
</template>

<script>
  import Uppy from '@uppy/core'
  import German from '@uppy/locales/lib/de_DE'
  import Dashboard from '@uppy/dashboard'
  import XHRUpload from '@uppy/xhr-upload'

  import '@uppy/core/dist/style.css'
  import '@uppy/dashboard/dist/style.css'

  export default {
    props: {
      uppyParams: {
        type: Object,
        default: () => { return {} }
      },
      successCallback: {
        type: Function,
      },
      completeCallback: {
        type: Function,
        default: () => { return {} }
      },
      getUploadParameters: {
        type: Function
      },
      uppyClass: {
        default: 'UppyDragDrop'
      }
    },
    created() {
      this.instance = Uppy(Object.assign(this.uppyInitParams, this.$props.uppyParams))
    },
    mounted() {
      this._setupDashboard()
      this._setupS3()
      this._setupCallback()
    },
    data() {
      return {
        instance: null,
        lastResult: null,
        postingFiles: 0
      }
    },
    watch: {
      postingFiles() {
        this.lastResult && this.postingFiles == 0 && this.$props.completeCallback(this.lastResult)
      }
    },
    computed: {
      uppyInitParams() {
        if (this.locale != 'de')
          return {}

        return { locale: German }
      }
    },
    methods: {
      reset() {
        this.instance.reset()
      },
      _setupDashboard() {
        this.instance.use(Dashboard, {
          thumbnailWidth: 100,
          height: '100%',
          animateOpenClose: true,
          proudlyDisplayPoweredByUppy: false,
          inline: true,
          target: "." + this.uppyClass,
          replaceTargetContent: true,
          showProgressDetails: true,
          disableThumbnailGenerator: true,
          browserBackButtonClose: true,
          metaFields: [{ id: 'name', name: 'Filename' }]
        })
      },
      _setupS3() {
        this.instance.use(XHRUpload, {
          endpoint: `${this.baseApiUrl}/inline/upload`,
          method: 'post',
          formData: true,
          fieldName: 'file',
          limit: 1,
          withCredentials: true,
          headers: {
            'Client-ID': process.env.VUE_APP_FRONTEND_CLIENT_ID
          },
          getResponseData(responseText, response) {
            return JSON.parse(responseText)
          }
        }).setMeta({ prefix: 'records/' })

      },
      _setupCallback() {
        this.instance.on('file-added', () => {
          this.postingFiles += 1
        })

        this.instance.on('file-removed', () => {
          if (this.postingFiles > 0)
            this.postingFiles -= 1
        })

        this.instance.on('upload-success', (file, res) => {
          if (!this.$props.successCallback)
            return Function.prototype

          this.$props.successCallback(file, res).finally(() => {
            if (this.postingFiles > 0)
              this.postingFiles -= 1
          })
        })

        this.instance.on('complete', (res) => {
          this.lastResult = res
        })
      }
    }
  }
</script>
<style lang="sass">
  .uppy-Dashboard-innerWrap
    max-height: 400px
    overflow: auto!important
</style>
